import { useNavigate } from 'react-router-dom';

import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneActivityLink: FunctionComponent<Props> = ({
    className = '',
    droneId,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const navigate = useNavigate();
    const { droneDetailsPage } = usePageRoutes();

    const handleClick = (clickEvent: { stopPropagation: VoidFunction }) => {
        clickEvent.stopPropagation();
        navigate(droneDetailsPage(droneId));
    };

    return (
        <div
            className={`${styles.droneActivityLink} ${className}`}
            data-testid={testId}
            onClick={handleClick}>
            {t.VIEW_RECENT_ACTIVITY}
        </div>
    );
};

export default DroneActivityLink;
